/**
 * Module: `export/docx-field-labels.ts` — underline bold field labels ending with `:`.
 * Matches PDF treatment of `**Résumé :**`-style labels in source blocks.
 */

/**
 * Adds single underline to bold runs whose visible text ends with `:`.
 */
export function enhanceDocxFieldLabels(documentXml: string): string {
  return documentXml.replace(
    /<w:r\b([^>]*)>([\s\S]*?)<\/w:r>/g,
    (run, attrs, inner) => {
      const isBold = /<w:b\b/.test(inner) || /<w:b\s*\/>/.test(inner);
      if (!isBold) return run;

      const text = Array.from(
        String(inner).matchAll(/<w:t\b[^>]*>([\s\S]*?)<\/w:t>/g)
      )
        .map((match) => match[1] ?? "")
        .join("");
      if (!/:\s*$/.test(text.trim())) return run;

      if (/<w:u\b/.test(inner)) return run;

      if (/<w:rPr>/.test(inner)) {
        const nextInner = inner.replace(
          /<w:rPr>([\s\S]*?)<\/w:rPr>/,
          (_m, rprInner) => `<w:rPr>${rprInner}<w:u w:val="single"/></w:rPr>`
        );
        return `<w:r${attrs}>${nextInner}</w:r>`;
      }

      return `<w:r${attrs}><w:rPr><w:b/><w:u w:val="single"/></w:rPr>${inner}</w:r>`;
    }
  );
}
